import React, { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';
import Proyeccion from './Proyeccion';
const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  { auth: { persistSession: false, storageKey: 'admin-supabase' } }
);

const PASSWORD = 'logiconnect_admin_2026';
const IVA = 0.16;
const ISR = 0.30;

export default function Admin() {
  const [autenticado, setAutenticado] = useState(false);
  const [pass, setPass] = useState('');
  const [errorPass, setErrorPass] = useState(false);
  const [activeTab, setActiveTab] = useState('crm');

  // CRM
  const [clientes, setClientes] = useState([]);
  const [showNuevoCliente, setShowNuevoCliente] = useState(false);
  const [nuevoCliente, setNuevoCliente] = useState({ nombre: '', contacto_nombre: '', contacto_email: '', contacto_telefono: '', plan: 'starter', monto_mensual: '', setup: '', estado: 'activo', fecha_inicio: '', notas: '' });
  const [editandoCliente, setEditandoCliente] = useState(null);
  const [editClienteData, setEditClienteData] = useState({});

  // Tareas
  const [tareas, setTareas] = useState([]);
  const [showNuevaTarea, setShowNuevaTarea] = useState(false);
  const [nuevaTarea, setNuevaTarea] = useState({ titulo: '', descripcion: '', prioridad: 'media', asignado_nombre: '', fecha_limite: '', ciclica: false, frecuencia_ciclica: 'semanal' });
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [filtroMiembro, setFiltroMiembro] = useState('todos');
  const [editandoTarea, setEditandoTarea] = useState(null);
  const miembros = ['Luis Eduardo', 'Otro miembro'];

  // Gastos
  const [gastos, setGastos] = useState([]);
  const [showNuevoGasto, setShowNuevoGasto] = useState(false);
  const [nuevoGasto, setNuevoGasto] = useState({ descripcion: '', monto: '', categoria: 'operativo', mes: new Date().toISOString().slice(0, 7) });

  useEffect(() => {
    if (!autenticado) return;
    cargarTodo();
  }, [autenticado]);

  const cargarTodo = async () => {
    const [{ data: c }, { data: t }, { data: g }] = await Promise.all([
      supabase.from('admin_clientes').select('*').order('created_at', { ascending: false }),
      supabase.from('admin_tareas').select('*').order('created_at', { ascending: false }),
      supabase.from('admin_gastos').select('*').order('created_at', { ascending: false }),
    ]);
    if (c) setClientes(c);
    if (t) setTareas(t);
    if (g) setGastos(g);
  };

  const login = () => {
    if (pass === PASSWORD) { setAutenticado(true); setErrorPass(false); }
    else setErrorPass(true);
  };

  // CRM
  const agregarCliente = async () => {
    if (!nuevoCliente.nombre) return;
    const { data } = await supabase.from('admin_clientes').insert({ ...nuevoCliente, monto_mensual: parseFloat(nuevoCliente.monto_mensual) || 0, setup: parseFloat(nuevoCliente.setup) || 0 }).select().single();
    if (data) setClientes([data, ...clientes]);
    setNuevoCliente({ nombre: '', contacto_nombre: '', contacto_email: '', contacto_telefono: '', plan: 'starter', monto_mensual: '', setup: '', estado: 'activo', fecha_inicio: '', notas: '' });
    setShowNuevoCliente(false);
  };

  const guardarCliente = async (id) => {
    const payload = { ...editClienteData, monto_mensual: parseFloat(editClienteData.monto_mensual) || 0, setup: parseFloat(editClienteData.setup) || 0 };
    await supabase.from('admin_clientes').update(payload).eq('id', id);
    setClientes(clientes.map(c => c.id === id ? { ...c, ...payload } : c));
    setEditandoCliente(null);
  };

  const eliminarCliente = async (id) => {
    await supabase.from('admin_clientes').delete().eq('id', id);
    setClientes(clientes.filter(c => c.id !== id));
  };

const generarInvitacion = async (cliente) => {
  const token = crypto.randomUUID();
  const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString();
  const { error } = await supabase.from('onboarding_tokens').insert({
    token,
    email: cliente.contacto_email || '',
    plan: cliente.plan || 'starter',
    nombre_empresa: cliente.nombre,
    usado: false,
    expires_at: expires,
  });
  if (error) { alert('Error: ' + error.message); return; }
    const link = `https://milogiconnect.com/registro?token=${token}`;
  try {
    await navigator.clipboard.writeText(link);
  } catch {
    const ta = document.createElement('textarea');
    ta.value = link; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
  }
  alert(`✅ Link generado:\n\n${link}\n\nVálido 7 días. Cópialo y envíaselo al cliente.`);
};

  // Tareas
  const agregarTarea = async () => {
    if (!nuevaTarea.titulo) return;
    const payload = { ...nuevaTarea, estado: 'pendiente' };
    if (!payload.fecha_limite) payload.fecha_limite = null;
    const { data } = await supabase.from('admin_tareas').insert(payload).select().single();
    if (data) setTareas([data, ...tareas]);
    setNuevaTarea({ titulo: '', descripcion: '', prioridad: 'media', asignado_nombre: '', fecha_limite: '', ciclica: false, frecuencia_ciclica: 'semanal' });
    setShowNuevaTarea(false);
  };

  const cambiarEstadoTarea = async (id, estado) => {
    const tarea = tareas.find(t => t.id === id);
    await supabase.from('admin_tareas').update({ estado }).eq('id', id);
    if (estado === 'completada' && tarea?.ciclica) {
      let nf = new Date(tarea.fecha_limite || new Date());
      if (tarea.frecuencia_ciclica === 'diaria') nf.setDate(nf.getDate() + 1);
      else if (tarea.frecuencia_ciclica === 'semanal') nf.setDate(nf.getDate() + 7);
      else if (tarea.frecuencia_ciclica === 'mensual') nf.setMonth(nf.getMonth() + 1);
      await supabase.from('admin_tareas').insert({ ...tarea, id: undefined, estado: 'pendiente', fecha_limite: nf.toISOString().split('T')[0] });
      setTimeout(cargarTodo, 500);
    }
    setTareas(tareas.map(t => t.id === id ? { ...t, estado } : t));
  };

  const eliminarTarea = async (id) => {
    await supabase.from('admin_tareas').delete().eq('id', id);
    setTareas(tareas.filter(t => t.id !== id));
  };

  // Gastos
  const agregarGasto = async () => {
    if (!nuevoGasto.descripcion || !nuevoGasto.monto) return;
    const { data } = await supabase.from('admin_gastos').insert({ ...nuevoGasto, monto: parseFloat(nuevoGasto.monto) }).select().single();
    if (data) setGastos([data, ...gastos]);
    setNuevoGasto({ descripcion: '', monto: '', categoria: 'operativo', mes: new Date().toISOString().slice(0, 7) });
    setShowNuevoGasto(false);
  };

  const eliminarGasto = async (id) => {
    await supabase.from('admin_gastos').delete().eq('id', id);
    setGastos(gastos.filter(g => g.id !== id));
  };

  // Cálculos financieros
  const mesActual = new Date().toISOString().slice(0, 7);
  const ingresoBrutoMensual = clientes.filter(c => c.estado === 'activo').reduce((a, c) => a + (parseFloat(c.monto_mensual) || 0), 0);
  const gastosMesActual = gastos.filter(g => g.mes === mesActual).reduce((a, g) => a + (parseFloat(g.monto) || 0), 0);
  const ivaACobrar = ingresoBrutoMensual * IVA;
  const ingresoNeto = ingresoBrutoMensual - gastosMesActual;
  const isrEstimado = ingresoNeto > 0 ? ingresoNeto * ISR : 0;
  const ingresoPostImpuestos = ingresoNeto - isrEstimado;
  const proyeccion1m = ingresoPostImpuestos;
  const proyeccion6m = ingresoPostImpuestos * 6;
  const proyeccion12m = ingresoPostImpuestos * 12;

  // SaaS KPIs
  const mrr = ingresoBrutoMensual;
  const arr = mrr * 12;
  const clientesActivos = clientes.filter(c => c.estado === 'activo').length;
  const clientesCancelados = clientes.filter(c => c.estado === 'cancelado').length;
  const totalClientes = clientes.length;
  const churn = totalClientes > 0 ? ((clientesCancelados / totalClientes) * 100).toFixed(1) : 0;
  const ltv = clientesActivos > 0 ? (mrr / clientesActivos) * 24 : 0; // promedio 24 meses de vida
  const cac = gastos.filter(g => g.categoria === 'marketing').reduce((a, g) => a + parseFloat(g.monto || 0), 0);
  const ltvCac = cac > 0 ? (ltv / cac).toFixed(1) : '∞';

  const planColor = { starter: '#00e5a0', business: '#3b82f6', 'a medida': '#8b5cf6' };
  const estadoClienteColor = { activo: '#00e5a0', pausado: '#f59e0b', cancelado: '#ef4444' };
  const prioridadColor = { alta: '#ef4444', media: '#f59e0b', baja: '#00e5a0' };
  const estadoTareaColor = { pendiente: '#6b7280', en_progreso: '#3b82f6', completada: '#00e5a0' };

  const tareasFiltradas = tareas.filter(t =>
    (filtroEstado === 'todos' || t.estado === filtroEstado) &&
    (filtroMiembro === 'todos' || t.asignado_nombre === filtroMiembro)
  );

  const miembrosUnicos = [...new Set(tareas.filter(t => t.asignado_nombre).map(t => t.asignado_nombre))];

  const s = {
    input: { width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '10px 12px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' },
    inputVerde: { width: '100%', background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' },
    label: { fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '4px' },
    btnGreen: { background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
    btnOutline: { background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer' },
    btnSm: { background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '4px 8px', fontSize: '11px', cursor: 'pointer' },
    card: { background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', marginBottom: '16px' },
  };

  if (!autenticado) {
    return (
      <div style={{ minHeight: '100vh', background: '#0a0c10', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '12px', padding: '40px', width: '320px' }}>
          <div style={{ fontSize: '20px', fontWeight: '700', color: '#00e5a0', marginBottom: '8px' }}>Admin LogiConnect</div>
          <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '24px' }}>Acceso restringido</div>
          <input type="password" value={pass} onChange={e => setPass(e.target.value)} onKeyDown={e => e.key === 'Enter' && login()}
            placeholder="Contraseña" style={{ ...s.input, marginBottom: '12px', border: errorPass ? '1px solid #ef4444' : '1px solid #222730' }} />
          {errorPass && <div style={{ fontSize: '12px', color: '#ef4444', marginBottom: '12px' }}>Contraseña incorrecta</div>}
          <button onClick={login} style={{ ...s.btnGreen, width: '100%', padding: '12px' }}>Entrar</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0a0c10', color: '#e8eaf0' }}>
      <div style={{ background: '#111318', borderBottom: '1px solid #222730', padding: '0 32px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <img src="/logo-dark.svg" alt="LogiConnect" style={{ height: '28px' }} />
          <span style={{ fontSize: '12px', color: '#ef4444', fontWeight: '600', padding: '2px 8px', background: 'rgba(239,68,68,0.1)', borderRadius: '4px' }}>ADMIN</span>
        </div>
        <button onClick={() => setAutenticado(false)} style={s.btnOutline}>Cerrar sesión</button>
      </div>

      <div style={{ padding: '28px 32px' }}>
        <div style={{ display: 'flex', gap: '4px', marginBottom: '28px', borderBottom: '1px solid #222730' }}>
          {[{ id: 'crm', label: 'CRM' }, { id: 'tareas', label: 'Tareas' }, { id: 'costos', label: 'Cost Management' }, { id: 'proyeccion', label: 'Proyección' }].map(tab => (
            <div key={tab.id} onClick={() => setActiveTab(tab.id)}
              style={{ padding: '10px 20px', cursor: 'pointer', fontSize: '13px', fontWeight: '500', color: activeTab === tab.id ? '#00e5a0' : '#6b7280', borderBottom: `2px solid ${activeTab === tab.id ? '#00e5a0' : 'transparent'}`, marginBottom: '-1px' }}>
              {tab.label}
            </div>
          ))}
        </div>

        {/* ── CRM ── */}
        {activeTab === 'crm' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: '#fff' }}>Clientes LogiConnect</div>
                <div style={{ fontSize: '13px', color: '#6b7280' }}>{clientes.filter(c => c.estado === 'activo').length} activos · ${ingresoBrutoMensual.toLocaleString('es-MX')} MRR</div>
              </div>
              <button onClick={() => setShowNuevoCliente(true)} style={s.btnGreen}>+ Nuevo cliente</button>
            </div>

            {showNuevoCliente && (
              <div style={{ ...s.card, border: '1px solid #00e5a0', marginBottom: '20px' }}>
                <div style={{ fontSize: '14px', fontWeight: '600', color: '#fff', marginBottom: '16px' }}>Nuevo Cliente</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '12px' }}>
                  <div><label style={s.label}>Nombre empresa *</label><input value={nuevoCliente.nombre} onChange={e => setNuevoCliente({...nuevoCliente, nombre: e.target.value})} style={s.input} /></div>
                  <div><label style={s.label}>Contacto</label><input value={nuevoCliente.contacto_nombre} onChange={e => setNuevoCliente({...nuevoCliente, contacto_nombre: e.target.value})} style={s.input} /></div>
                  <div><label style={s.label}>Email</label><input value={nuevoCliente.contacto_email} onChange={e => setNuevoCliente({...nuevoCliente, contacto_email: e.target.value})} style={s.input} /></div>
                  <div><label style={s.label}>Teléfono</label><input value={nuevoCliente.contacto_telefono} onChange={e => setNuevoCliente({...nuevoCliente, contacto_telefono: e.target.value})} style={s.input} /></div>
                  <div><label style={s.label}>Plan</label>
                    <select value={nuevoCliente.plan} onChange={e => setNuevoCliente({...nuevoCliente, plan: e.target.value})} style={s.input}>
                      <option value="starter">Starter</option><option value="business">Business</option><option value="a medida">A Medida</option>
                    </select>
                  </div>
                  <div><label style={s.label}>Mensualidad (MXN)</label><input type="number" value={nuevoCliente.monto_mensual} onChange={e => setNuevoCliente({...nuevoCliente, monto_mensual: e.target.value})} style={s.input} /></div>
                  <div><label style={s.label}>Setup (MXN)</label><input type="number" value={nuevoCliente.setup} onChange={e => setNuevoCliente({...nuevoCliente, setup: e.target.value})} style={s.input} /></div>
                  <div><label style={s.label}>Fecha inicio</label><input type="date" value={nuevoCliente.fecha_inicio} onChange={e => setNuevoCliente({...nuevoCliente, fecha_inicio: e.target.value})} style={{ ...s.input, colorScheme: 'dark' }} /></div>
                  <div><label style={s.label}>Estado</label>
                    <select value={nuevoCliente.estado} onChange={e => setNuevoCliente({...nuevoCliente, estado: e.target.value})} style={s.input}>
                      <option value="activo">Activo</option><option value="pausado">Pausado</option><option value="cancelado">Cancelado</option>
                    </select>
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}><label style={s.label}>Notas</label><textarea value={nuevoCliente.notas} onChange={e => setNuevoCliente({...nuevoCliente, notas: e.target.value})} rows={2} style={{ ...s.input, resize: 'vertical', fontFamily: 'inherit' }} /></div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}><button onClick={agregarCliente} style={s.btnGreen}>Guardar</button><button onClick={() => setShowNuevoCliente(false)} style={s.btnOutline}>Cancelar</button></div>
              </div>
            )}

            <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>{['Empresa', 'Contacto', 'Plan', 'Mensualidad', 'Setup', 'Inicio', 'Estado', 'Notas', ''].map(h => (
                    <th key={h} style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', padding: '12px 16px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' }}>{h}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {clientes.map((c, i) => (
                    <tr key={c.id} style={{ background: i % 2 === 0 ? 'transparent' : '#0d1117' }}>
                      {editandoCliente === c.id ? (
                        <>
                          <td style={{ padding: '8px' }}><input value={editClienteData.nombre ?? c.nombre} onChange={e => setEditClienteData({...editClienteData, nombre: e.target.value})} style={s.inputVerde} /></td>
                          <td style={{ padding: '8px' }}><input value={editClienteData.contacto_nombre ?? c.contacto_nombre ?? ''} onChange={e => setEditClienteData({...editClienteData, contacto_nombre: e.target.value})} style={s.inputVerde} /></td>
                          <td style={{ padding: '8px' }}><select value={editClienteData.plan ?? c.plan} onChange={e => setEditClienteData({...editClienteData, plan: e.target.value})} style={s.inputVerde}><option value="starter">Starter</option><option value="business">Business</option><option value="a medida">A Medida</option></select></td>
                          <td style={{ padding: '8px' }}><input type="number" value={editClienteData.monto_mensual ?? c.monto_mensual} onChange={e => setEditClienteData({...editClienteData, monto_mensual: e.target.value})} style={s.inputVerde} /></td>
                          <td style={{ padding: '8px' }}><input type="number" value={editClienteData.setup ?? c.setup} onChange={e => setEditClienteData({...editClienteData, setup: e.target.value})} style={s.inputVerde} /></td>
                          <td style={{ padding: '8px' }}><input type="date" value={editClienteData.fecha_inicio ?? c.fecha_inicio ?? ''} onChange={e => setEditClienteData({...editClienteData, fecha_inicio: e.target.value})} style={{ ...s.inputVerde, colorScheme: 'dark' }} /></td>
                          <td style={{ padding: '8px' }}><select value={editClienteData.estado ?? c.estado} onChange={e => setEditClienteData({...editClienteData, estado: e.target.value})} style={s.inputVerde}><option value="activo">Activo</option><option value="pausado">Pausado</option><option value="cancelado">Cancelado</option></select></td>
                          <td style={{ padding: '8px' }}><input value={editClienteData.notas ?? c.notas ?? ''} onChange={e => setEditClienteData({...editClienteData, notas: e.target.value})} style={s.inputVerde} /></td>
                          <td style={{ padding: '8px' }}><div style={{ display: 'flex', gap: '4px' }}><button onClick={() => guardarCliente(c.id)} style={s.btnGreen}>💾</button><button onClick={() => setEditandoCliente(null)} style={s.btnSm}>✕</button></div></td>
                        </>
                      ) : (
                        <>
                          <td style={{ padding: '12px 16px', fontSize: '13px', color: '#e8eaf0', fontWeight: '600' }}>{c.nombre}</td>
                          <td style={{ padding: '12px 16px', fontSize: '12px', color: '#9ca3af' }}>{c.contacto_nombre || '—'}</td>
                          <td style={{ padding: '12px 16px' }}><span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: `${planColor[c.plan] || '#6b7280'}18`, color: planColor[c.plan] || '#6b7280', fontWeight: '600' }}>{c.plan}</span></td>
                          <td style={{ padding: '12px 16px', fontSize: '13px', color: '#00e5a0', fontWeight: '700' }}>${parseFloat(c.monto_mensual).toLocaleString('es-MX')}</td>
                          <td style={{ padding: '12px 16px', fontSize: '12px', color: '#6b7280' }}>${parseFloat(c.setup).toLocaleString('es-MX')}</td>
                          <td style={{ padding: '12px 16px', fontSize: '12px', color: '#6b7280' }}>{c.fecha_inicio || '—'}</td>
                          <td style={{ padding: '12px 16px' }}><span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: `${estadoClienteColor[c.estado]}18`, color: estadoClienteColor[c.estado], fontWeight: '600' }}>{c.estado}</span></td>
                          <td style={{ padding: '12px 16px', fontSize: '11px', color: '#6b7280', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.notas || '—'}</td>
                          <td style={{ padding: '12px 16px' }}><div style={{ display: 'flex', gap: '4px' }}>
  <button onClick={() => generarInvitacion(c)} style={{ ...s.btnSm, color: '#00e5a0', borderColor: '#00e5a0' }}>🔗</button>
  <button onClick={() => { setEditandoCliente(c.id); setEditClienteData({}); }} style={s.btnSm}>✏️</button>
  <button onClick={() => eliminarCliente(c.id)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '13px' }}>🗑️</button>
</div></td>
                        </>
                      )}
                    </tr>
                  ))}
                  {clientes.length === 0 && <tr><td colSpan="9" style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin clientes registrados</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ── TAREAS ── */}
        {activeTab === 'tareas' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#fff' }}>Tareas Internas</div>
              <button onClick={() => setShowNuevaTarea(true)} style={s.btnGreen}>+ Nueva tarea</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '24px' }}>
              {[{ label: 'Pendientes', value: tareas.filter(t => t.estado === 'pendiente').length, color: '#6b7280' }, { label: 'En progreso', value: tareas.filter(t => t.estado === 'en_progreso').length, color: '#3b82f6' }, { label: 'Completadas', value: tareas.filter(t => t.estado === 'completada').length, color: '#00e5a0' }].map((k, i) => (
                <div key={i} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: `2px solid ${k.color}` }}>
                  <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', marginBottom: '8px' }}>{k.label}</div>
                  <div style={{ fontSize: '28px', fontWeight: '700', color: k.color }}>{k.value}</div>
                </div>
              ))}
            </div>

            {showNuevaTarea && (
              <div style={{ ...s.card, border: '1px solid #00e5a0', marginBottom: '20px' }}>
                <div style={{ fontSize: '14px', fontWeight: '600', color: '#fff', marginBottom: '16px' }}>Nueva Tarea</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                  <div style={{ gridColumn: '1 / -1' }}><label style={s.label}>Título *</label><input value={nuevaTarea.titulo} onChange={e => setNuevaTarea({...nuevaTarea, titulo: e.target.value})} style={s.input} /></div>
                  <div style={{ gridColumn: '1 / -1' }}><label style={s.label}>Descripción</label><textarea value={nuevaTarea.descripcion} onChange={e => setNuevaTarea({...nuevaTarea, descripcion: e.target.value})} rows={2} style={{ ...s.input, resize: 'vertical', fontFamily: 'inherit' }} /></div>
                  <div><label style={s.label}>Prioridad</label><select value={nuevaTarea.prioridad} onChange={e => setNuevaTarea({...nuevaTarea, prioridad: e.target.value})} style={s.input}><option value="alta">Alta</option><option value="media">Media</option><option value="baja">Baja</option></select></div>
                  <div><label style={s.label}>Miembro</label><input value={nuevaTarea.asignado_nombre} onChange={e => setNuevaTarea({...nuevaTarea, asignado_nombre: e.target.value})} placeholder="Nombre del miembro" style={s.input} /></div>
                  <div><label style={s.label}>Fecha límite</label><input type="date" value={nuevaTarea.fecha_limite} onChange={e => setNuevaTarea({...nuevaTarea, fecha_limite: e.target.value})} style={{ ...s.input, colorScheme: 'dark' }} /></div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingTop: '20px' }}>
                    <input type="checkbox" checked={nuevaTarea.ciclica} onChange={e => setNuevaTarea({...nuevaTarea, ciclica: e.target.checked})} style={{ width: '16px', height: '16px', accentColor: '#00e5a0', cursor: 'pointer' }} />
                    <span style={{ fontSize: '13px', color: '#9ca3af' }}>Tarea cíclica 🔄</span>
                  </div>
                  {nuevaTarea.ciclica && <div><label style={s.label}>Frecuencia</label><select value={nuevaTarea.frecuencia_ciclica} onChange={e => setNuevaTarea({...nuevaTarea, frecuencia_ciclica: e.target.value})} style={s.input}><option value="diaria">Diaria</option><option value="semanal">Semanal</option><option value="mensual">Mensual</option></select></div>}
                </div>
                <div style={{ display: 'flex', gap: '8px' }}><button onClick={agregarTarea} style={s.btnGreen}>Guardar</button><button onClick={() => setShowNuevaTarea(false)} style={s.btnOutline}>Cancelar</button></div>
              </div>
            )}

            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
              <select value={filtroMiembro} onChange={e => setFiltroMiembro(e.target.value)} style={{ background: '#111318', border: `1px solid ${filtroMiembro !== 'todos' ? '#8b5cf6' : '#222730'}`, borderRadius: '6px', padding: '8px 12px', color: filtroMiembro !== 'todos' ? '#8b5cf6' : '#6b7280', fontSize: '13px', cursor: 'pointer' }}>
                <option value="todos">Todos los miembros</option>
                {miembrosUnicos.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
              {[{ id: 'todos', label: 'Todas' }, { id: 'pendiente', label: 'Pendientes' }, { id: 'en_progreso', label: 'En progreso' }, { id: 'completada', label: 'Completadas' }].map(f => (
                <button key={f.id} onClick={() => setFiltroEstado(f.id)} style={{ padding: '6px 12px', borderRadius: '6px', border: `1px solid ${filtroEstado === f.id ? '#00e5a0' : '#222730'}`, background: filtroEstado === f.id ? 'rgba(0,229,160,0.06)' : 'transparent', color: filtroEstado === f.id ? '#00e5a0' : '#6b7280', fontSize: '12px', cursor: 'pointer' }}>{f.label}</button>
              ))}
            </div>

            {tareasFiltradas.map(t => (
              <div key={t.id} style={{ ...s.card, borderLeft: `3px solid ${prioridadColor[t.prioridad]}` }}>
                {editandoTarea === t.id ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <input value={t.titulo} onChange={e => setTareas(tareas.map(x => x.id === t.id ? {...x, titulo: e.target.value} : x))} style={s.inputVerde} />
                    <textarea value={t.descripcion || ''} onChange={e => setTareas(tareas.map(x => x.id === t.id ? {...x, descripcion: e.target.value} : x))} rows={2} style={{ ...s.inputVerde, fontFamily: 'inherit', resize: 'vertical' }} />
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <select value={t.prioridad} onChange={e => setTareas(tareas.map(x => x.id === t.id ? {...x, prioridad: e.target.value} : x))} style={{ ...s.inputVerde, width: 'auto' }}><option value="alta">Alta</option><option value="media">Media</option><option value="baja">Baja</option></select>
                      <input value={t.asignado_nombre || ''} onChange={e => setTareas(tareas.map(x => x.id === t.id ? {...x, asignado_nombre: e.target.value} : x))} placeholder="Miembro" style={{ ...s.inputVerde, width: 'auto' }} />
                      <input type="date" value={t.fecha_limite || ''} onChange={e => setTareas(tareas.map(x => x.id === t.id ? {...x, fecha_limite: e.target.value} : x))} style={{ ...s.inputVerde, colorScheme: 'dark', width: 'auto' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button onClick={async () => { await supabase.from('admin_tareas').update({ titulo: t.titulo, descripcion: t.descripcion, prioridad: t.prioridad, asignado_nombre: t.asignado_nombre, fecha_limite: t.fecha_limite }).eq('id', t.id); setEditandoTarea(null); }} style={s.btnGreen}>Guardar</button>
                      <button onClick={() => setEditandoTarea(null)} style={s.btnOutline}>Cancelar</button>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                    <input type="checkbox" checked={t.estado === 'completada'} onChange={e => cambiarEstadoTarea(t.id, e.target.checked ? 'completada' : 'pendiente')}
                      style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#00e5a0', marginTop: '2px', flexShrink: 0 }} />
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span style={{ fontSize: '14px', fontWeight: '600', color: t.estado === 'completada' ? '#6b7280' : '#e8eaf0', textDecoration: t.estado === 'completada' ? 'line-through' : 'none' }}>{t.titulo}</span>
                          {t.ciclica && <span style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '10px', background: 'rgba(139,92,246,0.1)', color: '#8b5cf6', fontWeight: '600' }}>🔄 {t.frecuencia_ciclica}</span>}
                        </div>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <select value={t.estado} onChange={e => cambiarEstadoTarea(t.id, e.target.value)} style={{ background: `${estadoTareaColor[t.estado]}18`, border: `1px solid ${estadoTareaColor[t.estado]}40`, color: estadoTareaColor[t.estado], borderRadius: '6px', padding: '3px 8px', fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>
                            <option value="pendiente">Pendiente</option><option value="en_progreso">En progreso</option><option value="completada">Completada</option>
                          </select>
                          <button onClick={() => setEditandoTarea(t.id)} style={s.btnSm}>✏️</button>
                          <button onClick={() => eliminarTarea(t.id)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '13px' }}>🗑️</button>
                        </div>
                      </div>
                      {t.descripcion && <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '6px' }}>{t.descripcion}</div>}
                      <div style={{ display: 'flex', gap: '12px' }}>
                        <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '10px', background: `${prioridadColor[t.prioridad]}18`, color: prioridadColor[t.prioridad], fontWeight: '600' }}>{t.prioridad === 'alta' ? '↑ Alta' : t.prioridad === 'media' ? '→ Media' : '↓ Baja'}</span>
                        {t.asignado_nombre && <span style={{ fontSize: '11px', color: '#8b5cf6' }}>👤 {t.asignado_nombre}</span>}
                        {t.fecha_limite && <span style={{ fontSize: '11px', color: new Date(t.fecha_limite) < new Date() && t.estado !== 'completada' ? '#ef4444' : '#6b7280' }}>📅 {t.fecha_limite}</span>}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
            {tareasFiltradas.length === 0 && <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280', fontSize: '13px', background: '#111318', borderRadius: '10px', border: '1px solid #222730' }}>Sin tareas.</div>}
          </div>
        )}

        {/* ── COST MANAGEMENT ── */}
        {activeTab === 'costos' && (
          <div>
            <div style={{ fontSize: '18px', fontWeight: '700', color: '#fff', marginBottom: '20px' }}>Cost Management</div>

            {/* SaaS KPIs */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '16px', marginBottom: '24px' }}>
              {[
                { label: 'MRR', value: `$${mrr.toLocaleString('es-MX')}`, color: '#00e5a0', sub: 'Ingreso mensual recurrente' },
                { label: 'ARR', value: `$${arr.toLocaleString('es-MX')}`, color: '#00e5a0', sub: 'Ingreso anual recurrente' },
                { label: 'Churn', value: `${churn}%`, color: churn > 5 ? '#ef4444' : '#00e5a0', sub: `${clientesCancelados} cancelados` },
                { label: 'LTV promedio', value: `$${ltv.toLocaleString('es-MX', { maximumFractionDigits: 0 })}`, color: '#8b5cf6', sub: 'Vida estimada 24 meses' },
                { label: 'LTV / CAC', value: ltvCac, color: ltvCac === '∞' || parseFloat(ltvCac) >= 3 ? '#00e5a0' : '#ef4444', sub: cac > 0 ? `CAC $${cac.toLocaleString('es-MX')}` : 'Sin gastos marketing' },
              ].map((k, i) => (
                <div key={i} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: `2px solid ${k.color}` }}>
                  <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', color: '#6b7280', marginBottom: '8px' }}>{k.label}</div>
                  <div style={{ fontSize: '22px', fontWeight: '700', color: k.color, marginBottom: '4px' }}>{k.value}</div>
                  <div style={{ fontSize: '11px', color: '#6b7280' }}>{k.sub}</div>
                </div>
              ))}
            </div>
            
            {/* KPIs financieros */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
              {[
                { label: 'Ingreso bruto mensual', value: `$${ingresoBrutoMensual.toLocaleString('es-MX')}`, color: '#00e5a0', sub: 'Antes de impuestos' },
                { label: 'IVA a cobrar (16%)', value: `$${ivaACobrar.toLocaleString('es-MX', { maximumFractionDigits: 0 })}`, color: '#f59e0b', sub: 'Por trasladar al SAT' },
                { label: 'Gastos del mes', value: `$${gastosMesActual.toLocaleString('es-MX')}`, color: '#ef4444', sub: mesActual },
                { label: 'Ingreso neto', value: `$${ingresoNeto.toLocaleString('es-MX')}`, color: '#3b82f6', sub: 'Bruto - gastos' },
              ].map((k, i) => (
                <div key={i} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: `2px solid ${k.color}` }}>
                  <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', color: '#6b7280', marginBottom: '8px' }}>{k.label}</div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: k.color, marginBottom: '4px' }}>{k.value}</div>
                  <div style={{ fontSize: '11px', color: '#6b7280' }}>{k.sub}</div>
                </div>
              ))}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '24px' }}>
              {[
                { label: 'ISR estimado (30%)', value: `$${isrEstimado.toLocaleString('es-MX', { maximumFractionDigits: 0 })}`, color: '#ef4444', sub: 'Sobre ingreso neto' },
                { label: 'Después de impuestos', value: `$${ingresoPostImpuestos.toLocaleString('es-MX', { maximumFractionDigits: 0 })}`, color: '#00e5a0', sub: 'Neto - ISR' },
                { label: 'Margen efectivo', value: `${ingresoBrutoMensual > 0 ? ((ingresoPostImpuestos / ingresoBrutoMensual) * 100).toFixed(1) : 0}%`, color: '#8b5cf6', sub: 'Sobre ingreso bruto' },
              ].map((k, i) => (
                <div key={i} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: `2px solid ${k.color}` }}>
                  <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', color: '#6b7280', marginBottom: '8px' }}>{k.label}</div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: k.color, marginBottom: '4px' }}>{k.value}</div>
                  <div style={{ fontSize: '11px', color: '#6b7280' }}>{k.sub}</div>
                </div>
              ))}
            </div>

            {/* Proyecciones */}
            <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px', marginBottom: '24px' }}>
              <div style={{ fontSize: '14px', fontWeight: '600', color: '#fff', marginBottom: '16px' }}>Proyecciones (después de impuestos)</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                {[
                  { label: '1 mes', value: proyeccion1m, desc: 'Proyección inmediata' },
                  { label: '6 meses', value: proyeccion6m, desc: 'Siguiente semestre' },
                  { label: '12 meses', value: proyeccion12m, desc: 'Proyección anual' },
                ].map((p, i) => (
                  <div key={i} style={{ background: '#0d1117', borderRadius: '8px', padding: '16px', textAlign: 'center' }}>
                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '2px' }}>{p.label}</div>
                    <div style={{ fontSize: '28px', fontWeight: '800', color: '#00e5a0', marginBottom: '4px' }}>${p.value.toLocaleString('es-MX', { maximumFractionDigits: 0 })}</div>
                    <div style={{ fontSize: '11px', color: '#6b7280' }}>{p.desc}</div>
                  </div>
                ))}
              </div>
            </div>

{/* Calculadora nómina */}
            <NominaCalc s={s} />
            {/* Gastos */}
            <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
              <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#fff' }}>Gastos Operativos</span>
                <button onClick={() => setShowNuevoGasto(true)} style={{ background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', color: '#00e5a0', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', cursor: 'pointer', fontWeight: '600' }}>+ Agregar</button>
              </div>
              {showNuevoGasto && (
                <div style={{ padding: '16px 20px', borderBottom: '1px solid #222730', background: 'rgba(0,229,160,0.03)' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '12px' }}>
                    <div><label style={s.label}>Descripción</label><input value={nuevoGasto.descripcion} onChange={e => setNuevoGasto({...nuevoGasto, descripcion: e.target.value})} placeholder="Vercel, Supabase..." style={s.input} /></div>
                    <div><label style={s.label}>Monto (MXN)</label><input type="number" value={nuevoGasto.monto} onChange={e => setNuevoGasto({...nuevoGasto, monto: e.target.value})} style={s.input} /></div>
                    <div><label style={s.label}>Categoría</label>
                      <select value={nuevoGasto.categoria} onChange={e => setNuevoGasto({...nuevoGasto, categoria: e.target.value})} style={s.input}>
                        <option value="hosting">Hosting</option><option value="software">Software</option><option value="marketing">Marketing</option><option value="nomina">Nómina</option><option value="operativo">Operativo</option><option value="otro">Otro</option>
                      </select>
                    </div>
                    <div><label style={s.label}>Mes</label><input type="month" value={nuevoGasto.mes} onChange={e => setNuevoGasto({...nuevoGasto, mes: e.target.value})} style={{ ...s.input, colorScheme: 'dark' }} /></div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}><button onClick={agregarGasto} style={s.btnGreen}>Guardar</button><button onClick={() => setShowNuevoGasto(false)} style={s.btnOutline}>Cancelar</button></div>
                </div>
              )}
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>{['Descripción', 'Categoría', 'Mes', 'Monto', ''].map(h => (
                    <th key={h} style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', padding: '12px 16px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' }}>{h}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {gastos.map((g, i) => (
                    <tr key={g.id} style={{ background: i % 2 === 0 ? 'transparent' : '#0d1117' }}>
                      <td style={{ padding: '12px 16px', fontSize: '13px', color: '#e8eaf0' }}>{g.descripcion}</td>
                      <td style={{ padding: '12px 16px', fontSize: '12px', color: '#9ca3af' }}>{g.categoria}</td>
                      <td style={{ padding: '12px 16px', fontSize: '12px', color: '#6b7280' }}>{g.mes}</td>
                      <td style={{ padding: '12px 16px', fontSize: '13px', color: '#ef4444', fontWeight: '600' }}>${parseFloat(g.monto).toLocaleString('es-MX')}</td>
                      <td style={{ padding: '12px 16px' }}><button onClick={() => eliminarGasto(g.id)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '13px' }}>🗑️</button></td>
                    </tr>
                  ))}
                  {gastos.length === 0 && !showNuevoGasto && <tr><td colSpan="5" style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin gastos registrados</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}
      {activeTab === 'proyeccion' && (
          <Proyeccion ingresoBrutoMensual={ingresoBrutoMensual} clientesActivos={clientes.filter(c => c.estado === 'activo').length} />
        )}
      </div>
    </div>
  );
  function NominaCalc({ s }) {
  const [salario, setSalario] = React.useState('');
  const [mostrar, setMostrar] = React.useState(false);

  const resultado = salario ? (() => {
    const neto = parseFloat(salario);
    const imss = neto * 0.30;
    const infonavit = neto * 0.05;
    const isr = neto * 0.10;
    const total = neto + imss + infonavit;
    return { neto, imss, infonavit, isr, total };
  })() : null;

  return (
    <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', marginBottom: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: mostrar ? '16px' : '0' }}>
        <div>
          <span style={{ fontSize: '14px', fontWeight: '600', color: '#fff' }}>Calculadora de Nómina</span>
          <span style={{ fontSize: '12px', color: '#6b7280', marginLeft: '12px' }}>IMSS + Infonavit + ISR estimado</span>
        </div>
        <button onClick={() => setMostrar(!mostrar)} style={{ background: 'rgba(139,92,246,0.1)', border: '1px solid rgba(139,92,246,0.2)', color: '#8b5cf6', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', cursor: 'pointer', fontWeight: '600' }}>{mostrar ? 'Ocultar' : 'Calcular'}</button>
      </div>
      {mostrar && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div>
              <label style={s.label}>Salario neto mensual (MXN)</label>
              <input type="number" value={salario} onChange={e => setSalario(e.target.value)} placeholder="Ej: 10000" style={s.input} />
              <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>Lo que el empleado recibe en mano</div>
            </div>
            {resultado && (
              <div style={{ background: '#0d1117', borderRadius: '8px', padding: '16px' }}>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>Costo real para la empresa</div>
                {[
                  { label: 'Salario neto', value: resultado.neto, color: '#e8eaf0' },
                  { label: 'IMSS patronal (~30%)', value: resultado.imss, color: '#ef4444' },
                  { label: 'Infonavit (5%)', value: resultado.infonavit, color: '#f59e0b' },
                  { label: 'ISR retenido (~10%)', value: resultado.isr, color: '#6b7280', nota: 'Lo retiene el empleado' },
                  { label: 'Costo total empresa', value: resultado.total, color: '#00e5a0', bold: true },
                ].map((r, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: i < 4 ? '1px solid #222730' : 'none' }}>
                    <span style={{ fontSize: '12px', color: '#9ca3af' }}>{r.label}{r.nota ? <span style={{ fontSize: '10px', color: '#6b7280', marginLeft: '6px' }}>({r.nota})</span> : ''}</span>
                    <span style={{ fontSize: r.bold ? '14px' : '12px', fontWeight: r.bold ? '700' : '600', color: r.color }}>${r.value.toLocaleString('es-MX', { maximumFractionDigits: 0 })}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          {resultado && (
            <div style={{ fontSize: '11px', color: '#6b7280', padding: '8px 12px', background: 'rgba(245,158,11,0.05)', borderRadius: '6px', border: '1px solid rgba(245,158,11,0.15)' }}>
              ⚠️ Estimación aproximada. Las cuotas IMSS varían según el salario base de cotización, zona geográfica y tipo de contrato. Consulta a un contador para cifras exactas.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
}